export default __webpack_public_path__ + "static/media/yoga_girl.c58c53ce.svg";